export const INDIVIDUAL_ONBOARDING_LINK = 'individual';
export const SHARED_ONBOARDING_LINK = 'shared';

export const AUTOMATIC_DISAPPROVAL = 'automatic';
export const MANUAL_DISAPPROVAL = 'manual';
